(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initializeOsixProductGalleries = () => {
    document.querySelectorAll('[data-osix-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;

      const track = gallery.querySelector('.osix-product-gallery__track');
      const progressBar = gallery.querySelector('.osix-product-gallery__progress-bar');
      const thumbs = Array.from(gallery.querySelectorAll('[data-osix-gallery-thumb]'));
      if (!track) return;

      const visibleSlides = () => Array.from(track.children).filter((slide) => getComputedStyle(slide).display !== 'none');
      const desktopQuery = window.matchMedia('(min-width: 990px)');
      let activeIndex = 0;

      const playVideos = () => {
        gallery.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.play().catch(() => {});
        });
      };

      const setActive = (index, scrollMobile = false) => {
        const slides = visibleSlides();
        if (!slides.length) return;

        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === activeIndex;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });

        if (scrollMobile && !desktopQuery.matches) {
          track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
        }

        if (progressBar) {
          const width = 100 / slides.length;
          progressBar.style.width = `${width}%`;
          progressBar.style.transform = `translateX(${activeIndex * 100}%)`;
        }
      };

      const updateFromScroll = () => {
        if (desktopQuery.matches) return;
        const slides = visibleSlides();
        if (!slides.length) return;
        const trackLeft = track.getBoundingClientRect().left;
        let nearestIndex = 0;
        let nearest = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < nearest) {
            nearest = distance;
            nearestIndex = index;
          }
        });
        setActive(nearestIndex);
      };

      let startX = 0;
      let startScroll = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!track.classList.contains('is-dragging')) return;
        track.scrollLeft = startScroll - (event.clientX - startX);
      });

      const finishDrag = (event) => {
        if (!track.classList.contains('is-dragging')) return;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('scroll', updateFromScroll, { passive: true });
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => setActive(Number(thumb.dataset.index))));
      window.addEventListener('resize', () => setActive(activeIndex));
      gallery.dataset.initialized = 'true';
      track.scrollLeft = 0;
      playVideos();
      setActive(0);
    });
  };

  document.addEventListener('DOMContentLoaded', initializeOsixProductGalleries);
  document.addEventListener('shopify:section:load', initializeOsixProductGalleries);
  initializeOsixProductGalleries();

  const formatOsixMoney = (cents, currency = 'EUR') => new Intl.NumberFormat(document.documentElement.lang || 'lt-LT', {
    style: 'currency',
    currency
  }).format(Number(cents || 0) / 100);

  const initializeOsixSmartBase = () => {
    document.querySelectorAll('[data-osix-fbt]').forEach((bundle) => {
      if (bundle.dataset.initialized === 'true') return;

      const inputs = Array.from(bundle.querySelectorAll('[data-osix-fbt-item]'));
      const total = bundle.querySelector('[data-osix-fbt-total]');
      const button = bundle.querySelector('[data-osix-fbt-add]');
      const status = bundle.querySelector('[data-osix-fbt-status]');

      const updateTotal = () => {
        const currency = bundle.closest('[data-osix-currency]')?.dataset.osixCurrency || 'EUR';
        const selected = inputs.filter((input) => input.checked);
        const cents = selected.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
        if (total) total.textContent = formatOsixMoney(cents, currency);
        if (button) {
          button.disabled = selected.length === 0;
          const label = button.querySelector('span');
          if (label) label.textContent = `${bundle.dataset.labelAdd} · ${formatOsixMoney(cents, currency)}`;
        }
      };

      inputs.forEach((input) => input.addEventListener('change', updateTotal));
      updateTotal();

      button?.addEventListener('click', async () => {
        const items = inputs.filter((input) => input.checked).map((input) => ({
          id: Number(input.dataset.variantId),
          quantity: 1
        }));
        if (!items.length || button.disabled) return;

        button.disabled = true;
        button.classList.add('loading');
        status.textContent = '';

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart add failed');

          status.textContent = bundle.dataset.labelAdded;
          const drawer = document.querySelector('cart-notification');
          if (drawer?.refreshAndOpen) await drawer.refreshAndOpen();
        } catch (error) {
          status.textContent = bundle.dataset.labelError;
          console.error(error);
        } finally {
          button.classList.remove('loading');
          button.disabled = false;
          updateTotal();
        }
      });

      bundle.dataset.initialized = 'true';
    });

    document.querySelectorAll('[data-osix-product-shipping]').forEach((message) => {
      const quantity = message.closest('.osix-product-summary')?.querySelector('.quantity__input');
      if (!quantity || message.dataset.initialized === 'true') return;

      const updateMessage = () => {
        const summary = message.closest('[data-osix-currency]');
        const currency = summary?.dataset.osixCurrency || 'EUR';
        const projected = Number(message.dataset.cartTotal || 0) +
          (Number(message.dataset.productPrice || 0) * Math.max(1, Number(quantity.value || 1)));
        const left = Math.max(0, Number(message.dataset.threshold || 5000) - projected);
        message.textContent = left > 0
          ? summary.dataset.osixShippingLeft.replace('__AMOUNT__', formatOsixMoney(left, currency))
          : summary.dataset.osixShippingFree;
      };

      quantity.addEventListener('change', updateMessage);
      quantity.addEventListener('input', updateMessage);
      updateMessage();
      message.dataset.initialized = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', initializeOsixSmartBase);
  document.addEventListener('shopify:section:load', initializeOsixSmartBase);
  initializeOsixSmartBase();

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
